module.exports = __webpack_public_path__ + "static/media/selector_dot.9d36942f.svg";